import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode } from "vue"

import {Groups, State, StateDescription, StatePermission} from "@/types/Order";
import {useGlobalSetting} from "@/lib/utils";

interface Props {
  variant?: any,
  readonly?: boolean,
  prependIcon?: string,
  prependInnerIcon?: string,
  permission?: number,
  disabled?: boolean,
  /** Kompakte Darstellung z.B. in Filterzeilen von Tabellen */
  density?: 'default' | 'comfortable' | 'compact',
  hideDetails?: boolean,
  clearable?: boolean,
  label?: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StateSelect',
  props: /*@__PURE__*/_mergeModels({
    variant: {},
    readonly: { type: Boolean, default: false },
    prependIcon: { default: "" },
    prependInnerIcon: { default: "" },
    permission: { default: Groups.tde.permission },
    disabled: { type: Boolean, default: false },
    density: { default: 'default' },
    hideDetails: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    label: { default: "Status" }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const modelValue = _useModel<State>(__props, "modelValue");

const items = Object.entries(State).map(([key, value]) => value)

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, { bottom: "" }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
        _createVNode(_component_v_select, {
          modelValue: modelValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
          class: _normalizeClass(_ctx.readonly ? 'custom-readonly' : ''),
          items: _unref(items),
          readonly: _ctx.readonly,
          variant: _ctx.variant ?? _unref(useGlobalSetting)().globalTextVariant,
          label: _ctx.label,
          "prepend-icon": _ctx.prependIcon,
          "prepend-inner-icon": _ctx.prependInnerIcon,
          disabled: _ctx.disabled,
          density: _ctx.density,
          "hide-details": _ctx.hideDetails,
          clearable: _ctx.clearable
        }, {
          item: _withCtx(({ props: itemProps, item }) => [
            (_unref(StatePermission)[item.raw] <= _ctx.permission)
              ? (_openBlock(), _createBlock(_component_v_list_item, _mergeProps({
                  key: 0,
                  subtitle: _unref(StateDescription)[item.raw]
                }, itemProps), null, 16, ["subtitle"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "class", "items", "readonly", "variant", "label", "prepend-icon", "prepend-inner-icon", "disabled", "density", "hide-details", "clearable"])
      ], 16)
    ]),
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "Status", -1))
    ]),
    _: 1,
    __: [1]
  }))
}
}

})